import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { VelocityComponent} from 'velocity-react';
import BaseButton from '../../Internals/BaseButton';
import plusClose from '../../../assets/imgs/plus2.svg';

require('velocity-animate');
require('velocity-animate/velocity.ui');

class PlusButton extends Component {

  state = {
      isOpen: true
  }

  onClick = ()=>{
      this.setState((prevState)=>({isOpen:!prevState.isOpen}));
      if(this.props.onClick){
          this.props.onClick();
      }
  }

  render() {
    const { round, ...props } = this.props;
    const cssClass = round ? 'plusButton plusButton--circle' : 'plusButton';

    return (
      <BaseButton className={cssClass} {...props} onClick={this.onClick}>
        <img src={plusClose} className={`plusButton__icon plusButton__icon${this.state.isOpen ? null : '--rotate'}`} />
      </BaseButton>
    );
  }
}

PlusButton.propTypes = {
  /** round button style */
  round: PropTypes.bool,
  /** open/close status - show plus or close icon */
  isOpen: PropTypes.bool
};
PlusButton.defaultProps = {
  round: false
};

export default PlusButton;
